define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {

        },

        init: function () {
            let nav = document.querySelector('.DeviceNav');
            
            let options = nav.querySelector('.DeviceNav-option');

            // Toggle menu
            nav.querySelectorAll('.toggle').forEach(el => 
                el.addEventListener('click', function (e) {
                    nav.classList.toggle('is-visible');
                    let logo = nav.querySelector('.DeviceNav-header .Header-logo');
                    let menu = nav.querySelector('.DeviceNav-list');
                    if (menu.classList.contains('visually-hidden')) {
                        menu.classList.toggle('visually-hidden');
                        menu.classList.toggle('is-visible');

                        document.body.classList.add('no-scroll');
                        document.body.style.maxWidth = '100%';
                        logo.classList.add('u-hidden');
                        options.classList.remove('u-hidden');
                   
                    } else {
                        menu.classList.remove('is-visible');
                        // Wait for CSS animation
                        setTimeout(function () {
                            nav.classList.remove('view-submenu');
                            menu.classList.add('visually-hidden');
                            document.body.classList.remove('no-scroll');
                            logo.classList.remove('u-hidden');
                            options.classList.add('u-hidden');
                            document.querySelectorAll('.DeviceNav-language').forEach(elm => elm.classList.remove('is-active'));
                        }, 200);
                    }
                })
            );

            // Add submenu hide bar
            let hideButton = document.createElement("div");
            hideButton.classList.add('hide-submenu');
            options.insertBefore(hideButton, options.firstChild);
            hideButton.addEventListener('click', function () {
                nav.classList.remove('view-submenu');
            });

            // submenu
            nav.querySelectorAll('.has-children span').forEach(el => 
                el.addEventListener('click', function (e) {
                    nav.classList.add('view-submenu');

                    nav.querySelector('.DeviceNav-parentName span').innerHTML = e.target.getAttribute('data-title');

                    // Hide all the submenus...
                    nav.querySelectorAll('.submenu').forEach(elm => elm.style.display = 'none');
                    // ...except for the one being called
                    e.target.closest('li').querySelector('.submenu').style.display = '';
                })
            );
        }
    });
});